/**
 * Finance Endpoint - matches PHP SDK Finance endpoint
 */

import { DreamscapeClient } from '../client';
import { Invoice, Balance, Collection } from '../types';

export class FinanceEndpoint {
  constructor(private client: DreamscapeClient) {}

  /**
   * Get balance
   */
  async getBalance(): Promise<Balance> {
    return this.client.request<Balance>('GET', 'finances/balance');
  }

  /**
   * Get invoices
   */
  async getInvoices(filters?: {
    customerId?: number;
    page?: number;
    limit?: number;
  }): Promise<Collection<Invoice>> {
    const params: Record<string, any> = {};
    if (filters?.customerId) params.customer_id = filters.customerId;
    if (filters?.page) params.page = filters.page;
    if (filters?.limit) params.limit = filters.limit;

    return this.client.request<Collection<Invoice>>('GET', 'finances/invoices', undefined, params);
  }

  /**
   * Get invoice details
   */
  async getInvoiceDetails(invoiceId: number): Promise<Invoice> {
    if (invoiceId < 1) {
      throw new Error('Invoice ID must be a positive integer');
    }

    return this.client.request<Invoice>('GET', `finances/invoices/${invoiceId}`);
  }
}

